import { Injectable, OnDestroy, OnInit } from '@angular/core';
import { debounceTime, filter, lastValueFrom, Subscription } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { momentCustom as moment, momentCustomInstance as momentInst } from '@projects/shared/src/app/utils/helper';
import { Constants } from '@app/constants';
import { CampaignService } from './campaign.service';
import { ToastService } from './toast/toast.service';
import { AuthenticationService } from '@app/core';
import { environment } from '@env/environment';
import { TelephonyProvider } from '../providers/telephony/telephony.provider';
import { FormBuilder, ValidatorFn, Validators } from '@angular/forms';
import { cloneDeep } from 'lodash';
import { AppConfigurationService } from './app.configuration.service';

@Injectable({
  providedIn: 'root',
})

//! !! This Service will be used for Bundle_Dealer realted codes only !!
export class BundleDealerService implements OnInit, OnDestroy {
  constructor(
    private campaignService: CampaignService,
    private toastService: ToastService,
    private httpClient: HttpClient,
    private authService: AuthenticationService,
    private telephony: TelephonyProvider,
    private fb: FormBuilder,
    private appConfig: AppConfigurationService,
  ) {
    this.subscriptions.push(
      this.telephony.voice.events.subscribe(async (event) => {
        switch (event.type) {
          case 'Call':
            switch (event.name) {
              case 'accept':
                const {
                  callSid,
                  callType,
                  btn,
                  tfn,
                  campaignCode,
                  campaignName,
                  tfnCampaignId,
                  tfnCampaignCode,
                  tfnCampaignName,
                } = event.data;
                this.connectedCallObj = { ...event.data };
                this.isUSH_Call = this.campaignService.getScriptSkillCode('USH_SKILLCODE').includes(tfnCampaignCode);
                this.isPortmoreCall = this.campaignService
                  .getScriptSkillCode('PORTMORE_SKILLCODE')
                  .includes(tfnCampaignCode);
                this.isPK_Call = this.campaignService.getScriptSkillCode('PK_SKILLCODE').includes(tfnCampaignCode);
                this.isUSH_Call && this.USHCallSetup();
                this.isPortmoreAllSkillsCall = this.isUSH_Call || this.isPortmoreCall;
                if (this.isUSH_Call || this.isPortmoreCall || this.isPK_Call) {
                  this.subscribeToSalesChanges();
                }

                this.bundleDealerSeassionParams.ucid = callSid;
                this.bundleDealerSeassionParams.tfn = tfn;
                this.bundleDealerSeassionParams.skill = tfnCampaignCode;
                this.bundleDealerSeassionParams.calltype = callType;
                
                break;
              case 'dispose':
                // const sid = event.data.callSid;
                // if (this.isPGECall) await this.bdCallDisposition(sid);
                this.resetBitsAndVariables();
                break;
            }
            break;
        }
      })
    );
    //pushing address residential/commerical change for portmore
    this.subscriptions.push(
      this.campaignService.addressForm.controls['resident'].valueChanges.subscribe((residentValue: any) => {
        if (residentValue && this.isPortmoreAllSkillsCall) {
          if (residentValue === 'Commercial') {
            if (!this.connectedCallObj?.isPAOfferTFN) {
              //* If true reduce steps to 3 --greetings, address and oet
              this.campaignService.steps = this.campaignService.stepsConstants.slice(0, 3);
            }
          } else {
            this.campaignService.steps = this.campaignService.stepsConstants;
          }
        }
      })
    );
  }
  isPortmoreAllSkillsCall: boolean = false;
  //* searchCustomer form inital value
  initialSearchCustomerValue = {
    firstName: '',
    lastName: '',
    street: '',
    city: '',
    state: '',
    zip: '',
  };
  //* Decalre ANY Variables HERE
  subscriptions = new Array<Subscription>();
  controlsSubscriptions = new Array<Subscription>();
  connectedCallObj: any = {};
  isPK_Call = false;
  isUSH_Call = false;
  isPortmoreCall = false;
  isUSHSpanishSkills = false;
  isPAStandardTFNs = false;
  isPAStandardCommercialTFNs = false;
  isPAStandardSkills = false;
  isCustomerSearcLoading: boolean = false;
  //Search for PGE Customer Modal Variables
  isPGESearchModalOpen: boolean = false;
  isHideResssetSeassion: boolean = false;
  customersData: any = [];
  // Custom validator function
  atLeastOneRequiredValidator: ValidatorFn = (control: any): { [key: string]: boolean } | null => {
    const controls = control['controls'];

    if (!controls) {
      return null;
    }

    for (const key in controls) {
      if (controls.hasOwnProperty(key) && controls[key].value) {
        return null; // At least one field has a value
      }
    }

    return { atLeastOneRequired: true }; // None of the fields have a value
  };
  searchCustomerForm = this.fb.group(
    {
      firstName: [''],
      lastName: [''],
      street: [''],
      city: [''],
      state: [''],
      zip: [''],
    },
    { validators: [this.atLeastOneRequiredValidator] }
  );

  //BD Seassion API Params
  bundleDealerSession: any = {};
  validations: any = { serviceableProviders: '', providerCodes: [] };
  bd: any = {
    warmMessage: 'Note: Please wait. The Bundle Dealer is loading....',
    dfMessage: 'Note: Please wait. The Bundle Dealer is loading....',
  };
  bdObjectx: any = {};

  bundleDealerSeassionParams: any = {
    addr: '',
    apt: '',
    zip: '',
    fname: '',
    lname: '',
    phn: '',
    email: '',
    agentid: '',
    agentName: '',
    customer: 'N',
    mso: '',
    skill: '',
    ucid: '',
    center: '',
    flow: 'retail',
    verifyUCID: false,
    tfn: '',
    isworkbenchcall: '',
    IBOIDNumber: '',
    calltype: '',
    externalId: '',
    isCustomerInfoModified: true,
    residentialType: '',
    serviceType: '',
  };

  ngOnInit(): void { }

  getConfirmNumber(): string {
    let number: string = '';

    number = this.campaignService.greetingForm.value.confirmPhoneNumber
      ? this.campaignService.greetingForm.value.confirmPhoneNumber
      : this.bundleDealerSession[this.bundleDealerSeassionParams.phn];

    return number;
  }

  updateOrderPostedInCacheOrder(sessionId: string, orderPlaced?: boolean) {
    if (typeof orderPlaced == 'undefined') {
      orderPlaced = true;
    }
    var phn = this.campaignService.greetingForm.value.confirmPhoneNumber
      ? this.campaignService.greetingForm.value.confirmPhoneNumber
      : this.bundleDealerSession[this.bundleDealerSeassionParams.phn];
    let kv = this.bundleDealerSession[phn];

    if (kv != 'undefined') {
      for (var i = 0; i < kv.sids.length; i++) {
        if (kv.sids[i].sid == sessionId) {
          kv.sids[i].ocn = orderPlaced;
          break;
        }
      }
    }
  }

  async createSession(): Promise<string> {
    this.campaignService.checkPrevoiusFormData();
    //get updated data if any
    this.bundleDealerSeassionParams = {
      ...this.bundleDealerSeassionParams,
      addr: this.campaignService.addressForm.value.address,
      apt: this.campaignService.addressForm.value.apartment,
      zip: this.campaignService.addressForm.value.zip,
      customer: this.campaignService.addressForm.value.customerType,
      isworkbenchcall: this.campaignService.addressForm.value.workoutBench === 'WithoutWorkBench' ? '0' : '1',
      fname: this.campaignService.greetingForm.value.firstName,
      lname: this.campaignService.greetingForm.value.lastName,
      phn: this.campaignService.greetingForm.value.confirmPhoneNumber,
      email: this.campaignService.addressForm.value.email,
      flow: this.campaignService.tfnFlow,
      residentialType: this.campaignService.addressForm.value.residentType,
      serviceType:
        this.campaignService.addressForm.value.resident === 'Commercial'
          ? 'Business'
          : this.campaignService.addressForm.value.resident,
      isCustomerInfoModified: this.campaignService.isCustomerInfoChanged,
      agentName: this.authService.getUserFullName(),
      center: this.authService.authData.Location,
      agentid: this.authService.authData?.UserSettings.IbexId,
      externalId: this.campaignService.providerCustomerData.externalId,
      googleApiResponse: this.campaignService.addressForm.value.mapData
    };
    //* adding exra params to FE
    if (this.isUSH_Call) {
      this.bundleDealerSeassionParams.PAStd =
        this.campaignService.greetingForm.value.isEnroll && !this.campaignService.greetingForm.value.isSupplier
          ? 'Random'
          : this.campaignService.greetingForm.value.isEnroll && this.campaignService.greetingForm.value.isSupplier
            ? this.campaignService.greetingForm.value.supplier
            : 'NOPA';
      this.bundleDealerSeassionParams.OpCo = this.connectedCallObj?.randomProviders?.opCo
        ? this.connectedCallObj?.randomProviders?.opCo
        : '';
      //First Energy customer info modified check
      if (this.connectedCallObj.feCustomerData) {
        //let customerBTN = webdialer.formatFEBTN($scope.view.firstEnergy.customerContact, false);
        this.bundleDealerSeassionParams.externalId = this.connectedCallObj.feCustomerData.externalId;
        this.campaignService.providerCustomerData.externalId = this.connectedCallObj.feCustomerData.externalId;
        //bdObject.phn = customerBTN ? customerBTN : webdialer.getConfirmNumberOrBTN();

        if (this.bundleDealerSeassionParams.isCustomerInfoModified) {
          this.bundleDealerSeassionParams.isCustomerInfoModified = true;
          this.bdObjectx = this.bundleDealerSeassionParams;
        } else {
          this.bundleDealerSeassionParams.isCustomerInfoModified = false;
          this.bdObjectx = this.bundleDealerSeassionParams;
        }
      }
    }

    let iframeUrlDecider = this.campaignService.addressForm.value.resident;
    if (this.isUSH_Call) {
      if (this.connectedCallObj.isCommercialTFN) {
        iframeUrlDecider = 'Residential';
      }
    }
    switch (iframeUrlDecider) {
      case 'Residential':
        //first check if the session id already created?
        //if created then relay it
        //else create a new session id
        //then relay it
        let isNewSessionToCreate = false;
        let sessionId = '';
        let isSpecial = false;
        //let bdObjectx: any = undefined;

        let kv = this.bundleDealerSession[this.bundleDealerSeassionParams.phn];

        if (typeof kv == 'undefined') {
          //1st case undefined
          this.bundleDealerSession[this.bundleDealerSeassionParams.phn] = {
            bdx: this.bundleDealerSeassionParams,
            sids: [],
          };
          this.bdObjectx = this.bundleDealerSeassionParams;
          isNewSessionToCreate = true;
        } else if (kv.sids.length > 0 && kv.sids[kv.sids.length - 1].orderPlaced) {
          //2nd case successful order done
          kv.bdx.ucid = this.bundleDealerSeassionParams.ucid;
          this.bdObjectx = kv.bdx;
          this.bdObjectx.ucid = this.bundleDealerSeassionParams.ucid;
          isNewSessionToCreate = true;
        } else if (kv.sids.length == 0) {
          //3rd case after call disposing loading the same address again
          kv.bdx = this.bundleDealerSeassionParams;
          this.bdObjectx = this.bundleDealerSeassionParams;
          isNewSessionToCreate = true;
        } else {
          //4th case not qualifying, directly loading the last one
          kv.bdx.ucid = this.bundleDealerSeassionParams.ucid;
          this.bdObjectx = kv.bdx;
          sessionId = kv.sids[kv.sids.length - 1].sid;
          isNewSessionToCreate = false;
        }

        if (typeof this.bdObjectx != 'undefined') {
          if (
            !this.isPK_Call &&
            (this.bdObjectx.addr != this.bundleDealerSeassionParams.addr ||
              this.bdObjectx.zip != this.bundleDealerSeassionParams.zip ||
              this.bdObjectx.apt != this.bundleDealerSeassionParams.apt ||
              this.bdObjectx.isworkbenchcall != this.bundleDealerSeassionParams.isworkbenchcall ||
              this.bdObjectx.customer != this.bundleDealerSeassionParams.customer ||
              this.bdObjectx.IBOIDNumber != this.bundleDealerSeassionParams.IBOIDNumber ||
              this.bdObjectx.fname != this.bundleDealerSeassionParams.fname ||
              this.bdObjectx.lname != this.bundleDealerSeassionParams.lname ||
              this.bdObjectx.phn != this.bundleDealerSeassionParams.phn ||
              this.bdObjectx.email != this.bundleDealerSeassionParams.email ||
              this.bdObjectx.residentialType != this.bundleDealerSeassionParams.residentialType)
          ) {
            //6th case address changed so need to load new session
            this.bdObjectx = this.bundleDealerSeassionParams;
            isSpecial = true;
          }
          //* For PK
          else if (
            this.isPK_Call &&
            (this.bdObjectx.addr != this.bundleDealerSeassionParams.addr ||
              this.bdObjectx.zip != this.bundleDealerSeassionParams.zip ||
              this.bdObjectx.apt != this.bundleDealerSeassionParams.apt ||
              this.bdObjectx.isworkbenchcall != this.bundleDealerSeassionParams.isworkbenchcall ||
              this.bdObjectx.customer != this.bundleDealerSeassionParams.customer ||
              this.bdObjectx.IBOIDNumber != this.bundleDealerSeassionParams.IBOIDNumber ||
              this.bdObjectx.residentialType != this.bundleDealerSeassionParams.residentialType)
          ) {
            //6th case address changed so need to load new session
            this.bdObjectx = this.bundleDealerSeassionParams;
            isSpecial = true;
          }
        } else {
          //storing in the local context
          this.bdObjectx = this.bundleDealerSeassionParams;
        }

        if (isNewSessionToCreate || isSpecial) {
          this.validations.serviceableProviders = '';
          //console.log(new Date().toLocaleString() + '  ➤  bundleDealerSeassionParams ==> ', this.bundleDealerSeassionParams);
          const response: any = await lastValueFrom(
            this.httpClient
              .disableLoader()
              .post(`${Constants.APIS.BUNDLEDEALER.CREATE_SESSION}`, this.bundleDealerSeassionParams)
          );
          //console.log(response);

          let postData = JSON.parse(response.Result);
          this.campaignService.sessionid = postData.sessionId;

          if (typeof postData.responseInfo != 'undefined' && postData.responseInfo.responseCode == '200') {
            sessionId = postData.sessionId;

            let bdObject = this.bdObjectx;

            kv = this.bundleDealerSession[bdObject.phn];
            if (typeof kv == 'undefined') {
              this.bundleDealerSession[bdObject.phn] = [];
            } else if (kv.sids.length > 0) {
              for (var i = kv.sids.length - 1; i >= 0; i--) {
                if (!kv.sids[i].orderPlaced) {
                  kv.sids.splice(i, 1);
                }
              }
            }

            //no need to check the cache object
            //direct add order details
            this.bundleDealerSession[bdObject.phn].bdx = bdObject;
            this.bundleDealerSession[bdObject.phn].sids.push({ sid: sessionId, orderPlaced: false, ocn: false });

            this.bd.warmMessage =
              bdObject.isworkbenchcall == '1'
                ? 'Note: Rendering Bundler Dealer for Workbench'
                : 'Note: SessionId received ' + sessionId + '. Rendering Bundle Dealer';

            setTimeout(() => {
              this.bd.warmMessage =
                bdObject.isworkbenchcall == '1'
                  ? 'Note: Bundle Dealer Loaded for Workbench'
                  : 'Note: Bundle Dealer in viewing mode. SessionID: ' + sessionId;
            }, 5000);

            this.campaignService.oetInfo.oets[0].source =
              environment.bundleDealerUrl + '?sessionid=' + postData.sessionId;

            //this.oetInfo.selectedOetURL = $sce.trustAsResourceUrl(this.oetInfo.oets[0].source);
            this.campaignService.oetInfo.selectedOetURL = this.campaignService.oetInfo.oets[0].source;
            this.campaignService.oetInfo.toShow = true;
          } else {
            if (postData.status == '401' && !this.campaignService.oetInfo.toShow) {
              this.campaignService.oetInfo.errMessage = postData.data;
              this.campaignService.oetInfo.showError = true;
            }

            if (this.campaignService.stepperIndex == 2) {
              this.campaignService.oetInfo.toShow = true;
            }

            this.bd.warmMessage = 'Note: Got Error in BundleDealer Loading';
          }
        } else {
          this.bd.warmMessage = 'Note: Recalling Bundle Dealer for SessionID:' + sessionId;
          var iframeUrl =
            environment.bundleDealerSessionRecall +
            '?sessionid=' +
            sessionId +
            '&ucid=' +
            this.bundleDealerSeassionParams.ucid +
            '&calltype=' +
            this.bundleDealerSeassionParams.calltype;
          // var iframeUrl =
          //   'https://qa-webdialer.bundledealer.com/BundleDealer/ConsoleSessionRecall?sessionid={sessionid}&ucid={ucid}&calltype={calltype}';
          // iframeUrl = iframeUrl.replace('{sessionid}', sessionId);
          // iframeUrl = iframeUrl.replace('{ucid}', this.bundleDealerSeassionParams.ucid);
          // iframeUrl = iframeUrl.replace('{calltype}', this.bundleDealerSeassionParams.calltype);

          this.campaignService.oetInfo.oets[0].source = iframeUrl;
          //this.oetInfo.selectedOetURL = $sce.trustAsResourceUrl($scope.view.preserveData.oetInfo.oets[0].source);
          this.campaignService.oetInfo.selectedOetURL = this.campaignService.oetInfo.oets[0].source;
          this.campaignService.oetInfo.toShow = true;

          setTimeout(() => {
            this.bd.warmMessage = 'Note: Recalling Session in Loading State for SessionID:' + sessionId;
          }, 4000);
        }
        break;
      case 'Commercial':
        this.campaignService.oetInfo.oets[1].source =
          environment.bundleDealerCommercialUrl +
          '?tfn=' +
          //'https://apps.dgsworld.com/CommercialLead/iFrame.aspx?tfn=' +
          this.bundleDealerSeassionParams.tfn +
          '&fname=' +
          this.bundleDealerSeassionParams.fname +
          '&lname=' +
          this.bundleDealerSeassionParams.lname +
          '&address=' +
          this.bundleDealerSeassionParams.addr +
          '&city=' +
          this.campaignService.addressForm.value.city +
          '&zip=' +
          this.bundleDealerSeassionParams.zip +
          '&email=' +
          this.bundleDealerSeassionParams.email +
          '&phone=' +
          this.bundleDealerSeassionParams.phn +
          '&agentid=' +
          this.authService.authData?.UserSettings.IbexId;

        //this.oetInfo.selectedOetURL = $sce.trustAsResourceUrl($scope.view.preserveData.oetInfo.oets[0].source);
        this.campaignService.oetInfo.selectedOetURL = this.campaignService.oetInfo.oets[1].source;
        this.campaignService.oetInfo.toShow = true;
        break;
    }

    return this.campaignService.oetInfo.selectedOetURL;
  }

  async resetSession(): Promise<string> {
    this.bd.warmMessage = 'Note: Reset Session Request Generated.';
    this.campaignService.oetInfo.showError = false;
    //5th case reset session called
    //get updated data if any
    this.bundleDealerSeassionParams = {
      ...this.bundleDealerSeassionParams,
      addr: this.campaignService.addressForm.value.address,
      apt: this.campaignService.addressForm.value.apartment,
      zip: this.campaignService.addressForm.value.zip,
      customer: this.campaignService.addressForm.value.customerType,
      isworkbenchcall: this.campaignService.addressForm.value.workoutBench === 'WithoutWorkBench' ? '0' : '1',
      fname: this.campaignService.greetingForm.value.firstName,
      lname: this.campaignService.greetingForm.value.lastName,
      phn: this.campaignService.greetingForm.value.confirmPhoneNumber,
      email: this.campaignService.addressForm.value.email,
      flow: this.campaignService.tfnFlow,
      residentialType: this.campaignService.addressForm.value.residentType,
      serviceType:
        this.campaignService.addressForm.value.resident === 'Commercial'
          ? 'Business'
          : this.campaignService.addressForm.value.resident,
      isCustomerInfoModified: this.campaignService.isCustomerInfoChanged,
      agentName: this.authService.getUserFullName(),
      center: this.authService.authData.Location,
      agentid: this.authService.authData?.UserSettings.IbexId,
      externalId: this.campaignService.providerCustomerData.externalId,
    };
    //* adding exra params to FE
    if (this.isUSH_Call) {
      this.bundleDealerSeassionParams.PAStd =
        this.campaignService.greetingForm.value.isEnroll && !this.campaignService.greetingForm.value.isSupplier
          ? 'Random'
          : this.campaignService.greetingForm.value.isEnroll && this.campaignService.greetingForm.value.isSupplier
            ? this.campaignService.greetingForm.value.supplier
            : 'NOPA';
      this.bundleDealerSeassionParams.OpCo = this.connectedCallObj?.randomProviders?.opCo
        ? this.connectedCallObj?.randomProviders?.opCo
        : '';
      //First Energy customer info modified check
      if (this.connectedCallObj.feCustomerData) {
        //let customerBTN = webdialer.formatFEBTN($scope.view.firstEnergy.customerContact, false);
        this.bundleDealerSeassionParams.externalId = this.connectedCallObj.feCustomerData.externalId;
        //bdObject.phn = customerBTN ? customerBTN : webdialer.getConfirmNumberOrBTN();

        if (this.bundleDealerSeassionParams.isCustomerInfoModified) {
          this.bundleDealerSeassionParams.isCustomerInfoModified = true;
          this.bdObjectx = this.bundleDealerSeassionParams;
        } else {
          this.bundleDealerSeassionParams.isCustomerInfoModified = false;
          this.bdObjectx = this.bundleDealerSeassionParams;
        }
      }
    }

    this.bdObjectx = this.bundleDealerSeassionParams;

    const response: any = await lastValueFrom(
      this.httpClient
        .disableLoader()
        .post(`${Constants.APIS.BUNDLEDEALER.CREATE_SESSION}`, this.bundleDealerSeassionParams)
    );

    let postData = JSON.parse(response.Result);
    this.campaignService.sessionid = postData.sessionId;

    if (typeof postData.responseInfo != 'undefined' && postData.responseInfo.responseCode == '200') {
      let sessionId = postData.sessionId;

      this.bundleDealerSeassionParams = this.bdObjectx;

      let kv = this.bundleDealerSession[this.bundleDealerSeassionParams.phn];
      if (typeof kv == 'undefined') {
        this.bundleDealerSession[this.bundleDealerSeassionParams.phn] = {
          bdx: this.bundleDealerSeassionParams,
          sids: [],
        };
      } else if (kv.sids.length > 0) {
        for (var i = kv.sids.length - 1; i >= 0; i--) {
          if (!kv.sids[i].orderPlaced) {
            kv.sids.splice(i, 1);
          }
        }
      }

      this.bd.warmMessage =
        this.bundleDealerSeassionParams.isworkbenchcall == '1'
          ? 'Note: Reset Session For Workbench'
          : 'Note: Loading Bundle Dealer for the new received SessionId:' + sessionId;

      //no need to check the cache object
      //direct add order details

      this.bundleDealerSession[this.bundleDealerSeassionParams.phn].bdx = this.bundleDealerSeassionParams;
      this.bundleDealerSession[this.bundleDealerSeassionParams.phn].sids.push({ sid: sessionId, orderPlaced: false });

      this.campaignService.oetInfo.oets[0].source = environment.bundleDealerUrl + '?sessionid=' + postData.sessionId;

      this.campaignService.oetInfo.selectedOetURL = this.campaignService.oetInfo.oets[0].source;

      if (this.campaignService.stepperIndex == 2) this.campaignService.oetInfo.toShow = true;

      setTimeout(() => {
        this.bd.warmMessage =
          this.bundleDealerSeassionParams.isworkbenchcall == '1'
            ? 'Note: Bundler Dealer in Rendering mode for Workbench'
            : 'Note: Bundle Dealer in rendering mode. SessionId:' + sessionId;
      }, 4000);
    } else {
      if (postData.responseInfo.responseCode == '401' && !this.campaignService.oetInfo.toShow) {
        this.campaignService.oetInfo.errMessage = postData.data;
        this.campaignService.oetInfo.showError = true;
      }

      this.campaignService.oetInfo.toShow = true;

      setTimeout(() => {
        this.bd.warmMessage = 'Note: Facing error in reloading bundle dealer';
      }, 4000);
    }

    return this.campaignService.oetInfo.selectedOetURL;
  }

  async restoreBDOrder() {
    let inValid = false;
    this.campaignService.salesForm.value.sales?.forEach((o: any, i: any) => {
      if (i > 0 && !o.ocn) {
        inValid = true;
        return;
      }
    });

    if (inValid) {
      this.toastService.warning('Please complete or remove inappropriate sales information');
      return;
    }

    var phn = this.campaignService.greetingForm.value.confirmPhoneNumber
      ? this.campaignService.greetingForm.value.confirmPhoneNumber
      : this.bundleDealerSession[this.bundleDealerSeassionParams.phn];
    let kv = this.bundleDealerSession[phn];

    if (kv != 'undefined') {
      var arr = [];
      for (var i = 0; i < kv.sids.length; i++) {
        arr.push(kv.sids[i].sid);
        // if (!kv.sids[i].orderPlaced) {
        //   arr.push(kv.sids[i].sid);
        // }
      }

      if (arr.length > 0) {
        var obj = {
          Ucid: this.campaignService.customerCallSid,
          ListSessionId: arr,
        };

        const response: any = await lastValueFrom(
          this.httpClient.disableLoader().post(`${Constants.APIS.BUNDLEDEALER.RESTORE_ORDER}`, obj)
        );

        //let testdata = "{\"responseInfo\":{\"responseCode\":\"200\",\"responseMessage\":\"Success\"},\"postOrderModel\":[{\"sessionId\":\"260518141311DBQV90\",\"ocn\":\"GW136448535\",\"providerName\":\"AT&T\",\"rgu\":\"1\",\"offerType\":\"I\"},{\"sessionId\":\"260518145551DBQV90\",\"ocn\":\"GW136448536\",\"providerName\":\"directv\",\"rgu\":\"2\",\"offerType\":\"I\"}]}";
        let data = JSON.parse(response.Result);

        

        if (
          data &&
          data.responseInfo &&
          data.responseInfo.responseCode == '200' &&
          data.responseInfo.responseMessage == 'Success'
        ) {
          let remainingCount = 0;
          data.postOrderModel.forEach((o: any, i: any) => {
            this.updateOrderPostedInCacheOrder(o.sessionid);

            let totalSales = this.campaignService.salesForm.value.sales?.length
              ? this.campaignService.salesForm.value.sales?.length
              : 0;
            

            let sale = this.campaignService.salesForm.value.sales?.find((d: any) => d.ocn === o.ocn);
            let targetindex = this.campaignService.salesForm.value.sales?.findIndex((d: any) => d.ocn === o.ocn);

            if (typeof sale != 'undefined') {
              // if (o.providerName == 'AT&amp;T' || o.providerName == 'AT&T') {
              //   sale.mso = 'ATT';
              // } else sale.mso = o.providerName.replace(/ +/g, '').toUpperCase();
              sale.mso = o.providerName.replace(/ +/g, '').toUpperCase();
              sale.rgu = Number(o.rgu);
              sale.offertype =
                o.offerType.trim() === ''
                  ? ''
                  : this.campaignService.metadata.OfferType.find((d: any) => d.Code === o.offerType).Name;
              sale.isrouter = false;
              sale.sessionId = o.sessionId;

              this.campaignService.sales.at(Number(targetindex)).patchValue({
                ocn: sale.ocn,
                mso: sale.mso,
                rgu: sale.rgu,
                offerType: sale.offertype,
              });
            } else if (
              this.campaignService.salesForm.value.sales?.length == 1 &&
              !this.campaignService.salesForm.value.sales[0].ocn
            ) {
              this.campaignService.sales.at(0).patchValue({
                ocn: o.ocn,
                mso: o.providerName.replace(/ +/g, '').toUpperCase(),
                rgu: Number(o.rgu),
                offerType:
                  o.offerType.trim() === ''
                    ? ''
                    : this.campaignService.metadata.OfferType.find((d: any) => d.Code === o.offerType).Name,
              });

              // this.salesForm.value.sales[0].ocn = o.ocn;
              // if (o.providerName == 'AT&amp;T' || o.providerName == 'AT&T') this.salesForm.value.sales[0].mso = 'ATT';
              // else this.salesForm.value.sales[0].mso = o.providerName.replace(/ +/g, '').toUpperCase();
              // this.salesForm.value.sales[0].rgu = Number(o.rgu);
              // this.salesForm.value.sales[0].offertype =
              //   o.offerType.trim() === '' ? '' : this.metadata.OfferType.find((d: any) => d.Code === o.offerType).Name;
              this.campaignService.salesForm.value.sales[0].isrouter = false;
              this.campaignService.salesForm.value.sales[0].sessionId = o.sessionid;
            } else if (totalSales < this.campaignService.saleOrderLimit) {
              let ot = o.offerType;
              let offerType =
                ot.trim() === ''
                  ? ''
                  : this.campaignService.metadata.OfferType.find((d: any) => d.Code === o.offerType).Name;
              let mso = o.providerName.replace(/ +/g, '').toUpperCase();
              let rgus = Number(o.rgu);
              this.campaignService.sales.push(
                this.campaignService.createSaleFormGroupWithData(o.ocn, mso, rgus, offerType)
              );
            } else {
              remainingCount++;
            }
          });

          if (remainingCount > 0) {
            let msg =
              remainingCount +
              ' order(s) are in queue but you can proceed only ' +
              this.campaignService.saleOrderLimit +
              ' orders at a time';
            this.toastService.warning(msg);
          }


          if (this.isUSH_Call || this.isPortmoreCall || this.isPK_Call) {
            this.subscribeToSalesChanges();
          }
        }
      }
    }
  }

  //* Search For Pge Customer and collection of customer Function
  getCustomerDataFromBD(btn: any, clientCall: string = 'PGE') {
    if (clientCall === 'PGE') {
      this.isCustomerSearcLoading = true;
      this.httpClient
        .disableLoader()
        .get(
          `${Constants.APIS.BUNDLEDEALER.GET_CUSTOMER_INFO}?BTN=${encodeURIComponent(btn)}&CampaignCode=${this.campaignService.campaignCode
          }&CallSid=${this.campaignService.customerCallSid}`
        )
        .subscribe({
          next: (response: any) => {
            let data = null;
            if(response?.Result && response.Result !== "NoRecord Found"){
              data = JSON.parse(response.Result);
            }
            // Handle next value
            if (data && data.success) {
              this.mapPGECustomerData(data.record);
            } else {
              this.toastService.info('PGE data not found!');
            }
            this.isCustomerSearcLoading = false;
          },
          error: (error: any) => {
            // Handle error
            this.toastService.error('Someting went wrong');
            this.isCustomerSearcLoading = false;
          },
          complete: () => {
            // Handle complete
            // No errors, route to new page here
          },
        });
    } else if (clientCall === 'FE') {
      //* Setting Callback Number which was searched by the agent
      this.campaignService.greetingForm.controls['confirmCallbackNumber'].setValue(btn);
      this.isCustomerSearcLoading = true;
      //* btn format (xxx)xxx-xxxx
      let transformedBtn = this.formatPhoneNumberForFE(btn);

      //before fetching provider reset provider
      this.connectedCallObj.randomProviders = {};
      this.campaignService.greetingForm.controls.supplier.setValue('Random');
      this.campaignService.suppliers = [];
      this.campaignService.greetingForm.controls.isSupplier.setValue(false);
      this.connectedCallObj.randomProviders.price = '[xx]';
      this.connectedCallObj.randomProviders.discountedPrice = '[xx]';
      this.connectedCallObj.randomProviders.operatingCompany = 'opCo';

      this.httpClient
        .disableLoader()
        .get(
          `${Constants.APIS.BUNDLEDEALER.GET_CUSTOMER_INFO}?BTN=${encodeURIComponent(transformedBtn)}&CampaignCode=${this.campaignService.campaignCode
          }&CallSid=${this.campaignService.customerCallSid}`
        )
        .subscribe({
          next: (response: any) => {
            if (response?.Result === "NoRecord Found") {
              this.toastService.info('FE data not found!');
              this.isCustomerSearcLoading = false;
              return;
            }
            let data = JSON.parse(response.Result);
            // Handle next value
            if (data && data.success) {
              this.mapFECustomerData(data);
              this.toastService.info('FE data updated');
            } else {
              this.toastService.info('FE data not found!');
              //* data not found then still disabled residentalType
              // this.campaignService.appendBuilderState({
              //   ...this.campaignService.builderDataCurrentState,
              //   isResidentialDisabled: true,
              // });
              this.campaignService.disableResidentRadio = true;
            }
            this.isCustomerSearcLoading = false;
          },
          error: (error: any) => {
            // Handle error
            this.toastService.error('An error occurred while retrieving the customer record from Bundle Dealer.');
            this.isCustomerSearcLoading = false;
          },
          complete: () => {
            // Handle complete
            // No errors, route to new page here
          },
        });
    }
  }

  getRandomProviderFromBD(payload: any) {
    return this.httpClient.disableLoader().post(`${Constants.APIS.BUNDLEDEALER.GET_PROVIDER_INFO}`, payload);
  }

  //* Map customer data in fields
  mapPGECustomerData(c: any) {
   
    this.campaignService.providerCustomerData = c;
    //this.campaignService.bundleDealerSeassionParams.externalId = c.externalId;
    this.campaignService.greetingForm.controls.firstName.setValue(c.customer.firstName);
    this.campaignService.greetingForm.controls.lastName.setValue(c.customer.lastName);
    this.campaignService.greetingForm.controls.utlitityConfirmationEmail.setValue(c.customer.emailAddress);
    this.campaignService.greetingForm.controls.surveyEmail.setValue(c.customer.emailAddress);
    this.campaignService.greetingForm.controls['confirmPhoneNumber'].setValue(
      c.btn.replace(this.campaignService.countryCode, '') ?? ''
    );
    this.campaignService.greetingForm.controls['confirmCallbackNumber'].setValue(
      c.btn.replace(this.campaignService.countryCode, '') ?? ''
    );
    if (c.customer.order && c.customer.order.offer && c.customer.order.offer.length > 0) {
      this.campaignService.greetingForm.controls.movingDate.setValue(
        momentInst(c.customer.order.offer[0].requestedServiceDate)
      );
      this.campaignService.greetingForm.controls.isMovingDateChanged.setValue(true);
    }

    this.campaignService.addressForm.controls.address.setValue(c.customer.streetAddress);
    this.campaignService.addressForm.controls.city.setValue(c.customer.city);
    this.campaignService.addressForm.controls.state.setValue(c.customer.state);
    this.campaignService.addressForm.controls.zip.setValue(c.customer.zipCode);
    this.campaignService.addressForm.controls.email.setValue(c.customer.emailAddress);
    this.campaignService.checkPrevoiusFormData();
    this.isUSH_Call ? this.toastService.info('FE data updated!') : this.toastService.info('PGE data updated!');
    this.campaignService.greetingForm.controls['isConfirmPhoneNumber'].setValue(true);
    this.campaignService.greetingForm.controls['isConfirmCallbackNumber'].setValue(true);
  }

  async mapFECustomerData(d: any) {
    if (d) {
      
      //* Set provider
      this.campaignService.providerCustomerData = {
        customer: {
          firstName: d.partnerExchange.first_Name,
          lastName: d.partnerExchange.last_Name,
          streetAddress: d.partnerExchange.service_Address.street1,
          emailAddress: d.partnerExchange.customer_Email,
          order: {},
          state: d.partnerExchange.service_Address.state_Code,
          zipCode: d.partnerExchange.service_Address.zip_Code,
          city: d.partnerExchange.service_Address.city_Name,
        },
        btn: d.partnerExchange?.best_Contact_Number?.replace(this.campaignService.countryCode, '') ?? '',
        externalId: d?.externalId,
      };
      this.connectedCallObj.feCustomerData = cloneDeep(d);
      this.connectedCallObj.randomProviders = {};
      this.connectedCallObj.accountNumber = d?.partnerExchange?.account_Number;
      this.connectedCallObj.operatingCompany = this.connectedCallObj.randomProviders.operatingCompany =
        d.partnerExchange.partner_Specific_Data.name_Value_Pair.find(
          (x: any) => x.data_Name.toLowerCase() == 'operating_company'
        )?.data_Value;
      this.connectedCallObj.randomProviders.price = '[xx]';
      this.connectedCallObj.randomProviders.discountedPrice = '[xx]';
      let rateCode = d.partnerExchange.partner_Specific_Data.name_Value_Pair.find(
        (x: any) => x.data_Name.toLowerCase() == 'rate_code'
      );
      if (rateCode) {
        let value = this.getPropertyByRateCode(rateCode.data_Value, '-');
        switch (value) {
          case 'R': {
            // PropertyType = 'Residential';
            // $scope.view.cbOetInfo = false;
            // $scope.view.preserveData.oetInfo.selectedOet = "Residential";
            this.connectedCallObj.propertyType = 'Residential';
            this.connectedCallObj.residentialType = 'Residential';
            // setTimeout(() => {
            //   this.campaignService.disableScriptTool.next({
            //     key: 'ResidentialType',
            //     isDisable: true,
            //   });
            // }, 5000);
            break;
          }
          case 'G': {
            // PropertyType = 'Business';
            // $scope.view.cbOetInfo = true;
            // $scope.view.preserveData.oetInfo.selectedOet = "Commercial";
            this.connectedCallObj.propertyType = 'Business';
            this.connectedCallObj.residentialType = 'Commercial';

            break;
          }
          default: {
            //* ask munam
            //* TODO: propertyType change of tfn
            this.connectedCallObj.propertyType = this.connectedCallObj.isCommercialTFN ? 'Business' : 'Residential';
            this.connectedCallObj.residentialType = this.connectedCallObj.isCommercialTFN
              ? 'Commercial'
              : 'Residential';
            break;
          }
        }
      } else {
        //* ask munam
        //* TODO: propertyType change of tfn
        this.connectedCallObj.propertyType = this.connectedCallObj.isCommercialTFN ? 'Business' : 'Residential';
        this.connectedCallObj.residentialType = this.connectedCallObj.isCommercialTFN ? 'Commercial' : 'Residential';
      }
     
      //set Data for ongoing call component
      this.campaignService.lead.CustomerInfo.FirstName = d.partnerExchange.first_Name;
      this.campaignService.lead.CustomerInfo.LastName = d.partnerExchange.last_Name;
      this.campaignService.greetingForm.controls.firstName.setValue(d.partnerExchange.first_Name);
      this.campaignService.greetingForm.controls.lastName.setValue(d.partnerExchange.last_Name);
      this.campaignService.greetingForm.controls.sendSummaryEmail.setValue(d.partnerExchange.customer_Email);
      this.campaignService.greetingForm.controls.surveyEmail.setValue(d.partnerExchange.customer_Email);
      this.campaignService.greetingForm.controls['confirmPhoneNumber'].setValue(
        d.partnerExchange?.best_Contact_Number?.replace(/\D/g, "").replace(this.campaignService.countryCode, '') ?? ''
      );
      this.campaignService.greetingForm.controls['confirmCallbackNumber'].setValue(
        d.partnerExchange?.best_Contact_Number?.replace(/\D/g, "").replace(this.campaignService.countryCode, '') ?? ''
      );
      this.campaignService.greetingForm.controls['isConfirmPhoneNumber'].setValue(true);
      this.campaignService.greetingForm.controls['isConfirmCallbackNumber'].setValue(true);

      this.campaignService.addressForm.controls.address.setValue(d.partnerExchange.service_Address.street1);
      this.campaignService.addressForm.controls.city.setValue(d.partnerExchange.service_Address.city_Name);
      this.campaignService.addressForm.controls.state.setValue(d.partnerExchange.service_Address.state_Code);
      this.campaignService.addressForm.controls.zip.setValue(d.partnerExchange.service_Address.zip_Code);
      this.campaignService.addressForm.controls.email.setValue(d.partnerExchange.customer_Email);
      this.campaignService.addressForm.controls.resident.setValue(this.connectedCallObj.residentialType);

      this.campaignService.disableResidentRadio = true;
      //* mapping fields data for first API
      // let builderData = {
      //   ...this.campaignService.builderDataCurrentState,
      //   price: '[xx]',
      //   discountedPrice: '[xx]',
      //   opCo: this.connectedCallObj.operatingCompany,
      //   //* first step
      //   FirstName: d.partnerExchange.first_Name,
      //   LastName: d.partnerExchange.last_Name,
      //   emailAddress: d.partnerExchange.customer_Email,
      //   surveyEmail: d.partnerExchange.customer_Email,
      //   sendSummaryEmail: d.partnerExchange.customer_Email,
      //   confirmPhoneNumber: d.partnerExchange.best_Contact_Number,
      //   suppliers: [], //if calling both api for supplier and customer then empty
      //   supplier: 'Random',
      //   isSupplier: false,
      //   //*seconds step
      //   address: d.partnerExchange.service_Address.street1,
      //   email: d.partnerExchange.customer_Email,
      //   Zip: d.partnerExchange.service_Address.zip_Code,
      //   city: d.partnerExchange.service_Address.city_Name,
      //   state: d.partnerExchange.service_Address.state_Code,
      //   ResidentialType: this.connectedCallObj.residentialType,
      //   isPAServicesTFN: this.connectedCallObj.isPAServicesTFN,
      //   isPAOfferTFN: this.connectedCallObj.isPAOfferTFN,
      //   isCommercialTFN: this.connectedCallObj.isCommercialTFN,
      //   isResidentialDisabled: true,
      // };
      // console.log(new Date().toLocaleString() + '  ➤  builderData ==> ', builderData);
      // this.campaignService.appendBuilderState(builderData);

      //* Calling Provider API
      let payload = {
        ZipCode: d.partnerExchange.service_Address.zip_Code,
        UCID: this.connectedCallObj.callSid,
        TFN: this.connectedCallObj.tfn,
        ServiceType: this.connectedCallObj.propertyType,
        OpCo: this.connectedCallObj.operatingCompany,
        StreetAddress: d.partnerExchange.service_Address.street1,
        City: d.partnerExchange.service_Address.city_Name,
        State: d.partnerExchange.service_Address.state_Code,
        CampaignCode: this.campaignService.campaignCode,
      };
      this.feProviderAPI(payload);
    }
  }

  async feProviderAPI(payload: any) {
    const providersData: any = await lastValueFrom(this.getRandomProviderFromBD(payload));

    if (providersData && providersData?.Result) {
      let res = JSON.parse(providersData.Result);
      if (res.success) {
        if (res.prices.length > 0) {
          this.toastService.info('FE providers data found!');
          this.connectedCallObj.randomProviders = {};
          this.connectedCallObj.randomProviders.Prices = [];
          this.connectedCallObj.randomProviders.price = (res.prices[0].price * 100).toFixed(3);
          this.connectedCallObj.randomProviders.discountedPrice = (res.prices[0].discountedPrice * 100).toFixed(3);
          this.connectedCallObj.randomProviders.operatingCompany = res.prices[0].operatingCompany;
          this.connectedCallObj.randomProviders.opCo = res.prices[0].opCo;
          this.connectedCallObj.randomProviders.zipCode = res.zipCode;
          this.connectedCallObj.randomProviders.providers = res.prices[0].providers;
          this.campaignService.greetingForm.controls.supplier.setValue('Random');
          this.campaignService.suppliers = this.connectedCallObj.randomProviders.providers;
          this.campaignService.greetingForm.controls.isSupplier.setValue(false);
          //* update price for script
          // this.campaignService.appendBuilderState({
          //   ...this.campaignService.builderDataCurrentState,
          //   opCo: this.connectedCallObj.randomProviders.operatingCompany,
          //   price: (res.prices[0].price * 100).toFixed(3),
          //   discountedPrice: (res.prices[0].discountedPrice * 100).toFixed(3),
          //   suppliers: this.connectedCallObj.randomProviders.providers,
          //   isSupplier: false,
          //   supplier: 'Random',
          // });

          for (let i = 0; i < res.prices.length; i++) {
            let price = res.prices[i].price * 100;
            let discountPrice = res.prices[i].discountedPrice * 100;
            let opCoLabel =
              'OpCo : ' +
              res.prices[i].operatingCompany +
              ' | Price : ' +
              price.toFixed(3) +
              ' cents | Discounted Price : ' +
              discountPrice.toFixed(3) +
              ' cents';
            this.connectedCallObj.randomProviders.Prices.push({
              label: opCoLabel,
              value: res.prices[i].opCo,
              operatingCompany: res.prices[i].operatingCompany,
              price: price.toFixed(3),
              discountedPrice: discountPrice.toFixed(3),
              providers: res.prices[i].providers,
            });
          }
        }
      } else {
        //* update supplier for script
        this.campaignService.greetingForm.controls.supplier.setValue('Random');
        this.campaignService.suppliers = [];
        this.campaignService.greetingForm.controls.isSupplier.setValue(false);
        // this.campaignService.appendBuilderState({
        //   suppliers: [],
        //   isSupplier: false,
        //   supplier: 'Random',
        // });
        this.toastService.info('FE providers data not found!');
      }
    }
    let resType = this.campaignService.addressForm.controls.resident.value
      ? this.campaignService.addressForm.controls.resident.value
      : 'Residential';
    this.isHideResssetSeassion = this.isUSH_Call && !this.connectedCallObj.isCommercialTFN && resType === 'Commercial';
    
  }

  formatPhoneNumberForFE(phoneNumber: string) {
    // Remove the countrycode
    let cleaned = phoneNumber.replace(this.campaignService.countryCode, '');

    // Format the cleaned number
    let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

    if (match) {
      return `(${match[1]})${match[2]}-${match[3]}`;
    }

    // Return the original phone number if it doesn't match the expected format
    return phoneNumber;
  }

  getPropertyByRateCode(str: string, char: any) {
    var index = str.indexOf(char); // get the position of the special character
    if (index > -1 && index < str.length - 1) {
      // check if the special character exists and is not at the end
      return str.charAt(index + 1); // return the next character
    } else {
      return ''; // return an empty string
    }
  }

  USHCallSetup() {
    this.isUSHSpanishSkills = this.campaignService
      .getScriptSkillCode('PASTANDARDSKILLS')
      .includes(this.connectedCallObj.campaignCode);
    this.isPAStandardTFNs = this.campaignService
      .getScriptSkillCode('PASTANDARDTFNs')
      .includes(this.connectedCallObj.tfn);
    this.isPAStandardSkills = this.campaignService
      .getScriptSkillCode('PASTANDARDSKILLS')
      .includes(this.connectedCallObj.campaignCode);
    this.isPAStandardCommercialTFNs = this.campaignService
      .getScriptSkillCode('PASTANDARDCOMMERCIALTFNs')
      .includes(this.connectedCallObj.tfn);
    if (this.isPAStandardSkills || this.isPAStandardTFNs) {
      this.connectedCallObj.isPAOfferTFN = true;
      if (this.isPAStandardTFNs) {
        this.connectedCallObj.isPAServicesTFN = true;
      } else {
        this.connectedCallObj.isPAServicesTFN = false;
      }
    } else {
      //$scope.view.currentScriptNumber = 2;
      this.connectedCallObj.isPAOfferTFN = false;
      //$scope.view.firstEnergy.selectedPA = null;
    }

    //*Commercial TFNS
    if (this.isPAStandardCommercialTFNs) {
      this.connectedCallObj.isCommercialTFN = true;
      //* Todo: Update commercial in address
      this.connectedCallObj.residentialType = 'Commercial';
      // $scope.view.cbOetInfo = true;
      // $scope.view.preserveData.oetInfo.selectedOet = 'Commercial';
    } else {
      this.connectedCallObj.isCommercialTFN = false;
    }
    // console.log(
    //   'this.campaignService.builderDataCurrentState USHCallSetup ==> ',
    //   this.campaignService.builderDataCurrentState
    // );

    // let builderData = {
    //   ...this.campaignService.builderDataCurrentState,
    //   isPAServicesTFN: this.connectedCallObj.isPAServicesTFN,
    //   isPAOfferTFN: this.connectedCallObj.isPAOfferTFN,
    //   isCommercialTFN: this.connectedCallObj.isCommercialTFN,
    // };
    // this.campaignService.appendBuilderState(builderData);
    // console.log(new Date().toLocaleString() + '  ➤  this.campaignService.builderData USHCallSetup ==> ', this.campaignService.builderData);
  }

  closePgeSearchModal() {
    this.isPGESearchModalOpen = false;
    this.customersData = [];
    this.resetSearchCustomerForm();
  }

  openPgeSearchModal() {
    this.customersData = [];
    this.isPGESearchModalOpen = true;
  }

  handleSelectedCustomer(c: any, clientCall: string = 'PGE') {
  
    this.mapPGECustomerData(c);

    //* Close Modal & Clear Data
    this.closePgeSearchModal();

    //* Search From Number If USH OR FE
    this.isUSH_Call &&
      this.getCustomerDataFromBD(this.campaignService.getGreetingsFieldValue('confirmPhoneNumber'), 'FE');
  }

  //* reset PGE Customer Search Form
  resetSearchCustomerForm() {
    this.searchCustomerForm.reset(this.initialSearchCustomerValue);
  }

  getPGECustomers() {
    //* Validation check for atleast on entered value
    let isatLeastOneRequired = this.searchCustomerForm.hasError('atLeastOneRequired');
    if (isatLeastOneRequired) {
      this.toastService.info('At least one field is required.');
    } else {
      let formNumber = 1;
      this.httpClient
        .get(
          `${Constants.APIS.BUNDLEDEALER.GET_PGE_SEARCH_CUSTOMERS}?FirstName=${this.getFormControlValue(
            'firstName',
            formNumber
          )}&LastName=${this.getFormControlValue('lastName', formNumber)}&StreetAddress=${this.getFormControlValue(
            'street',
            formNumber
          )}&City=${this.getFormControlValue('city', formNumber)}&State=${this.getFormControlValue(
            'state',
            formNumber
          )}&ZipCode=${this.getFormControlValue('zip', formNumber)}&CampaignCode=${this.campaignService.campaignCode}&CallSid=${this.campaignService.customerCallSid}`
        )
        .subscribe((response: any) => {
          let data = JSON.parse(response.Result);
          if (data && data.success) {
            this.customersData = data.customers;
          }
        });
    }
  }
  getFECustomers() {
    //* Validation check for atleast on entered value
    let isatLeastOneRequired = this.searchCustomerForm.hasError('atLeastOneRequired');
    if (isatLeastOneRequired) {
      this.toastService.info('At least one field is required.');
    } else {
      let formNumber = 1;
      this.httpClient
        .get(
          `${Constants.APIS.BUNDLEDEALER.GET_PGE_SEARCH_CUSTOMERS}?FirstName=${this.getFormControlValue(
            'firstName',
            formNumber
          )}&LastName=${this.getFormControlValue('lastName', formNumber)}&StreetAddress=${this.getFormControlValue(
            'street',
            formNumber
          )}&City=${this.getFormControlValue('city', formNumber)}&State=${this.getFormControlValue(
            'state',
            formNumber
          )}&ZipCode=${this.getFormControlValue('zip', formNumber)}&CampaignCode=${this.campaignService.campaignCode}&CallSid=${this.campaignService.customerCallSid}`
        )
        .subscribe((response: any) => {
          let data = JSON.parse(response.Result);
          if (data && data.success) {
            for (let i = 0; i < data.customers.length; i++) {
              this.customersData.push({
                customer: {
                  firstName: data.customers[i]?.partnerExchange.first_Name,
                  lastName: data.customers[i]?.partnerExchange?.last_Name,
                  streetAddress: data.customers[i]?.partnerExchange?.service_Address?.street1,
                  emailAddress: data.customers[i]?.partnerExchange?.customer_Email,
                  order: {},
                  state: data.customers[i]?.partnerExchange?.service_Address?.state_Code,
                  zipCode: data.customers[i]?.partnerExchange?.service_Address?.zip_Code,
                  city: data.customers[i]?.partnerExchange?.service_Address?.city_Name,
                },
                btn: data.customers[i]?.partnerExchange?.best_Contact_Number,
                externalId: data.customers[i]?.externalId,
              });
            }
          }
        });
    }
  }

  //* get dynamically form control value
  //* formCode 1 for searchCustomerForm
  //* controlerName for control name inside group
  getFormControlValue(controlerName: string, formCode: number) {
    switch (formCode) {
      case 1:
        return this.searchCustomerForm.get(controlerName)?.value;
        break;
      // case 2:
      //   return '2nd Position';
      //   break;
      // case 3:
      //   return '3rd Position';
      //   break;
      // case 4:
      //   return '4th Position';
      //   break;
    }
    return '';
  }

  resetBitsAndVariables() {
    //* searchCustomer form inital value
    this.initialSearchCustomerValue = {
      firstName: '',
      lastName: '',
      street: '',
      city: '',
      state: '',
      zip: '',
    };

    this.connectedCallObj = {};
    this.isPK_Call = false;
    this.isUSH_Call = false;
    this.isPortmoreCall = false;
    this.isUSHSpanishSkills = false;
    this.isPAStandardTFNs = false;
    this.isPAStandardCommercialTFNs = false;
    this.isPAStandardSkills = false;
    this.isCustomerSearcLoading = false;
    //Search for PGE Customer Modal Variables
    this.isPGESearchModalOpen = false;
    this.isHideResssetSeassion = false;
    this.customersData = [];

    this.searchCustomerForm = this.fb.group(
      {
        firstName: [''],
        lastName: [''],
        street: [''],
        city: [''],
        state: [''],
        zip: [''],
      },
      { validators: [this.atLeastOneRequiredValidator] }
    );

    //BD Seassion API Params
    this.bundleDealerSession = {};
    this.validations = { serviceableProviders: '', providerCodes: [] };
    this.bd = {
      warmMessage: 'Note: Please wait. The Bundle Dealer is loading....',
      dfMessage: 'Note: Please wait. The Bundle Dealer is loading....',
    };
    this.bdObjectx = {};

    this.bundleDealerSeassionParams = {
      addr: '',
      apt: '',
      zip: '',
      fname: '',
      lname: '',
      phn: '',
      email: '',
      agentid: '',
      agentName: '',
      customer: 'N',
      mso: '',
      skill: '',
      ucid: '',
      center: '',
      flow: 'retail',
      verifyUCID: false,
      tfn: '',
      isworkbenchcall: '',
      IBOIDNumber: '',
      calltype: '',
      externalId: '',
      isCustomerInfoModified: true,
      residentialType: '',
      serviceType: '',
    };
  }

  // Subscribe to value changes for each sale FormGroup
  // bundledealerService

  subscribeToSalesChanges(): void {
    // Unsubscribe from ALL existing subscriptions before re-subscribing
    this.controlsSubscriptions.forEach(sub => sub.unsubscribe());
    this.controlsSubscriptions = [];

    this.campaignService.sales.controls.forEach((sale, index) => {
      const msoControl = sale.get('mso');
      const offerTypeControl = sale.get('offerType');

      if (msoControl) {
        this.controlsSubscriptions.push(
          msoControl.valueChanges.pipe(
            debounceTime(500),    // replaces setTimeout — cleaner, cancels on new emissions
            filter(Boolean)       // replaces `if (value)`
          ).subscribe(() => {
            const liveIndex = this.campaignService.sales.controls.indexOf(sale);
            if (liveIndex === -1) return; // Row was removed, bail out

            if (this.isUSH_Call || this.isPortmoreCall) {
              this.portmoreAddDeviceChangeRGU(liveIndex);
            } else if (this.isPK_Call) {
              this.pkAddConfrimationDropdown(liveIndex);
            }
          })
        );
      }

      if (offerTypeControl) {
        this.subscriptions.push(
          offerTypeControl.valueChanges.pipe(
            debounceTime(500),
            filter(Boolean)
          ).subscribe(() => {
            const liveIndex = this.campaignService.sales.controls.indexOf(sale);
            if (liveIndex === -1) return;
            if (this.isUSH_Call || this.isPortmoreCall) {
              this.portmoreAddDeviceChangeRGU(liveIndex);
            }
          })
        );
      }
    });
  }

  portmoreAddDeviceChangeRGU(index: number) {
    // Guard: index must be valid
    if (index < 0 || index >= this.campaignService.sales.controls.length) {
      console.warn(`portmoreAddDeviceChangeRGU: invalid index ${index}`);
      return;
    }
  

    let sale: any = this.campaignService.sales.controls[index].value;
    //   {
    //     "ocn": "34",
    //     "mso": "",
    //     "rgu": 1,
    //     "offerType": "",
    //     "deviceNumber": ""
    // }
    if ((sale.offerType === 'ATT WIRELESS' || sale.offerType === 'WIRELESS') && !sale.mso.includes('SPECTRUM')) {
      this.campaignService.sales.at(index).patchValue({
        rgu: 1,
        showExtraField: true,
        extraFieldName: 'deviceCount'
      });
      this.campaignService.sales.controls[index].get('deviceCount')?.setValidators([Validators.required]); // Add validators
      this.campaignService.sales.controls[index].get('deviceCount')?.updateValueAndValidity(); // Update validation status
      this.campaignService.sales.updateValueAndValidity();
    } else {
      this.campaignService.sales.at(index).patchValue({
        deviceCount: '',
        showExtraField: false,
        extraFieldName: ''
      });

      this.campaignService.sales.controls[index].get('deviceCount')?.clearValidators(); // Clear validators
      this.campaignService.sales.controls[index].get('deviceCount')?.updateValueAndValidity(); // Update validation status
    }
    if (sale.mso.includes('SPECTRUM')) {
      this.pkAddConfrimationDropdown(index);
    }
  }

  pkAddConfrimationDropdown(index: number) {
    let sale: any = this.campaignService.sales.controls[index].value;
    let isMsoExist = this.campaignService.getScriptSkillCode('PKMsoConfrimationDropDown').includes(sale.mso);
    if (isMsoExist) {
      this.campaignService.sales.at(index).patchValue({
        showExtraField: true,
        extraFieldName: 'pkSaleConfrimation'
      });
      this.campaignService.sales.controls[index].get('pkSaleConfrimation')?.setValidators([Validators.required]); // Add validators
      this.campaignService.sales.controls[index].get('pkSaleConfrimation')?.updateValueAndValidity(); // Update validation status
      this.campaignService.sales.updateValueAndValidity();
    } else {
      this.campaignService.sales.at(index).patchValue({
        pkSaleConfrimation: '',
        showExtraField: false,
        extraFieldName: ''
      });

      this.campaignService.sales.controls[index].get('pkSaleConfrimation')?.clearValidators(); // Clear validators
      this.campaignService.sales.controls[index].get('pkSaleConfrimation')?.updateValueAndValidity(); // Update validation status
      this.campaignService.sales.updateValueAndValidity();
    }
  }
  async getServiceableProviders() {
    const conf = this.appConfig.getByIdentifier('ScriptSkillCodesAndTFNS')?.Fields?.['IsBDServiceableProviderEnabled'] as string ?? 'false';
    const isEnabled = conf.toLowerCase() === "true";
    if(isEnabled && this.campaignService.sessionid !== ''){
      const obj = {
        CallSid: this.campaignService.customerCallSid,
        SessionId: this.campaignService.sessionid,
      };
  
      const response: any = await lastValueFrom(
        this.httpClient.disableLoader().post(`${Constants.APIS.BUNDLEDEALER.SERVICEABLE_PROVIDERS}`, obj)
      );
      if (response && response?.Result) {
        this.campaignService.bdServiceableProviders = JSON.parse(response.Result);
        this.campaignService.bdServiceableProviderMessages = this.campaignService.getBDServiceableProviderMessage();
      }
      //console.log('getServiceableProviders response',response);
    }
  }
  //* Remove Any Subscriptions HERE
  ngOnDestroy(): void {
    this.subscriptions.forEach((s: Subscription) => s.unsubscribe());
    this.controlsSubscriptions.forEach((s: Subscription) => s.unsubscribe());

  }
}
